import { heroTicker } from "@/mocks/melonData";

const HERO_BG =
  "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20background%20for%20a%20gossip%20fact-check%20media%20hub%2C%20warm%20cream%20paper%20texture%20with%20bold%20coral%20orange%20and%20fresh%20leaf%20green%20abstract%20geometric%20shapes%2C%20floating%20newspaper%20clippings%20and%20speech%20bubble%20and%20magnifier%20motifs%20arranged%20in%20a%20modern%20flat%20vector%20collage%2C%20soft%20gradients%2C%20airy%20negative%20space%2C%20high%20detail%20minimalist%20art%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=melon-hero-01&orientation=landscape";

export default function Hero() {
  return (
    <section id="hero" className="relative overflow-hidden bg-foreground-950">
      <img
        src={HERO_BG}
        alt="瓜核社吃瓜求真平台的暖色调编辑部风格背景插画"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/50 to-black/75" />

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 md:px-6 pt-32 pb-24 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs text-white backdrop-blur-sm whitespace-nowrap">
          <i className="ri-flashlight-line text-primary-300" />
          吃瓜求真 · 爆料可信度实锤与辟谣，把瓜看准
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl md:text-6xl leading-tight text-white">
          吃瓜最怕吃到假料
          <br className="hidden md:block" />
          <span className="text-primary-300">先来瓜核社验一验</span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm md:text-lg leading-relaxed text-white/85">
          我们把海量爆料整理成可核验的证据链：谁的瓜已经实锤、谁的还在存疑、谁又是在造谣带节奏。
          实时评级与取证时间线，帮你降低误判风险，吃得清楚明白。
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#cases"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm text-background-50 hover:bg-primary-400 transition-colors"
          >
            <i className="ri-search-eye-line text-base" />
            去查最新瓜
          </a>
          <a
            href="#contact"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/30 bg-white/10 px-7 py-3 text-sm text-white backdrop-blur-sm hover:bg-white/20 transition-colors"
          >
            <i className="ri-flag-2-line text-base" />
            我要求证 / 补充线索
          </a>
        </div>

        <p className="mt-5 inline-flex items-center gap-2 text-xs text-white/70 whitespace-nowrap">
          <i className="ri-time-line" />
          结论 10 分钟前更新 · 覆盖娱乐圈 · 网红达人 · 社会热点 · 体育赛事 · 商业人物
        </p>
      </div>

      {/* 热榜滚动条 */}
      <div className="relative border-t border-white/15 bg-black/30 backdrop-blur-sm">
        <div className="mx-auto flex w-full max-w-6xl items-center gap-4 px-4 md:px-6 py-3">
          <span className="hidden sm:inline-flex shrink-0 items-center gap-1.5 text-xs font-semibold text-primary-300 whitespace-nowrap">
            <i className="ri-fire-line" />
            本站热榜
          </span>
          <div className="scrollbar-none flex gap-2 overflow-x-auto">
            {heroTicker.map((t) => (
              <span
                key={t}
                className="shrink-0 rounded-full bg-white/10 px-3 py-1.5 text-xs text-white/90 whitespace-nowrap"
              >
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}